import { createReducer } from '@reduxjs/toolkit'

const initialState = {
  items: [],
  currentItem: {},
  pagination: {
    total: 1,
    page: 1,
    pageCount: 1
  },
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: ''
}

const authorizations = createReducer(initialState, {
  'authorizations/CLEAR_AUTHORIZATIONS': (state, action) => ({
    ...state,
    items: []
  }),
  'authorizations/GET': (state, action) => ({
    ...state,
    isFetching: true
  }),
  'authorizations/GET_SUCCESSFUL': (state, action) => {
    return {
      ...state,
      items: action.payload.response.data,
      isFetching: false,
      pagination: {
        total: action.payload.response.meta.total_count,
        pageCount: action.payload.response.meta.page_count,
        page: action.payload.current_page
      }
    }
  },
  'authorizations/GET_FAILURE': (state, action) => {
    return {
      ...state,
      isFetching: false,
      isError: true,
      errorMessage: action.payload
    }
  },
  'authorizations/DELETE': (state, action) => {
    return {
      ...state,
      isFetching: true
    }
  },
  'authorizations/DELETE_SUCCESSFUL': (state, action) => {
    return {
      ...state,
      items: state.items.filter(
        item => String(item.id) !== String(action.payload)
      ),
      isFetching: false
    }
  },
  'authorizations/DELETE_FAILURE': (state, action) => {
    return {
      ...state,
      isFetching: false,
      isError: true,
      errorMessage: action.payload
    }
  },
  'authorizations/GET_BY_ID': (state, action) => {
    return {
      ...state,
      isFetching: true
    }
  },
  'authorizations/GET_BY_ID_SUCCESSFUL': (state, action) => {
    return {
      ...state,
      isFetching: false,
      currentItem: action.payload
    }
  },
  'authorizations/GET_BY_ID_FAILURE': (state, action) => {
    return {
      ...state,
      isFetching: false,
      currentItem: {},
      errorMessage: action.payload
    }
  },
  'authorizations/CLEAR_CURRENT': (state, action) => {
    return {
      ...state,
      currentItem: {}
    }
  }
})

export default authorizations
